"use client"; // Error boundaries must be Client Components

import NextError from "next/error";
import { useEffect } from "react";
import { getBrowserPostHog } from "@/lib/posthog-browser";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    getBrowserPostHog()?.captureException(error);
  }, [error]);

  return (
    // global-error must include html and body tags
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
